import { useTranslation } from 'react-i18next';

import DemoTag from '@/components/DemoTag/DemoTag';
import { useDemoContext } from '@/hooks/DemoContext';
import { Support } from '@/services/types/commonResponse';

import styles from './styles.module.css';

interface ModaleRepartitionProps {
  produitName: string;
  montant: number;
  groupeSupport: Support[] | undefined;
}

const ContentModaleRepartition: React.FC<ModaleRepartitionProps> = ({ produitName, montant, groupeSupport }) => {
  const { t } = useTranslation();
  const { isDemo } = useDemoContext();

  return (
    <div className={styles.modalSupportRepartition}>
      <h2 className={styles.title}>{produitName}</h2>
      <h2 className={styles.amount}>
        {montant === null ? t('common.infoUnavailable') : t('format.currencyFlexible', { value: montant })}
        {isDemo && <DemoTag />}
      </h2>
      <ul>
        {groupeSupport?.map((support) => {
          return (
            <li key={support.supportId}>
              <div className={styles.infosSupport}>
                <div className={styles.typeSupport}>
                  <p>{support.nomSupport}</p>
                  <p className={styles.modeGestion}>Gestion {support.modeGestionLibelle}</p>
                </div>
                <p>
                  <span className="bolder-text">
                    {support.allocation === null
                      ? t('common.infoUnavailable')
                      : t('format.currencyFlexible', { value: support.allocation })}
                  </span>{' '}
                  {support.pourcentCategorie === null ? (
                    `(${t('common.infoUnavailable')})`
                  ) : (
                    <>
                      (<span className={styles.pourcentageSupport}>{support.pourcentCategorie}</span>%)
                    </>
                  )}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ContentModaleRepartition;
